// extracted by mini-css-extract-plugin
export default {"plate":"plate___Sjhk_","plate-img":"plate-img___atCVL"};